import { c as _c } from "react/compiler-runtime";
import { TextField } from "@flat-ui";
import { AnalyticsFeedbackOptionList } from "@components/analytics/in-house/feedback/analytics-feedback-option-list";
import { AnalyticsFeedbackStepLayout } from "@components/analytics/in-house/feedback/analytics-feedback-step";
import { OTHER_VALUE, ROLE_OPTIONS } from "@components/analytics/in-house/feedback/analytics-feedback-helper";

/** Requires a role to be selected; the "Other" free-text field is optional. */
function isValid(answers) {
  return answers.jobFunction.length > 0;
}

/** Single-select role step with an optional free-text "other" field. */
function AnalyticsFeedbackStep3Content(t0) {
  const $ = _c(14);
  const {
    answers,
    onAnswersChange
  } = t0;
  const shouldShowOther = answers.jobFunction === OTHER_VALUE;
  let t1;
  if ($[0] !== answers.jobFunction) {
    t1 = answers.jobFunction ? [answers.jobFunction] : [];
    $[0] = answers.jobFunction;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onAnswersChange) {
    t2 = role => onAnswersChange({
      jobFunction: role
    });
    $[2] = onAnswersChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <AnalyticsFeedbackOptionList options={ROLE_OPTIONS} selectedValues={t1} isMultiSelect={false} onToggle={t2} />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== answers.jobFunctionOther || $[8] !== onAnswersChange || $[9] !== shouldShowOther) {
    t4 = shouldShowOther && <TextField fullWidth={true} placeholder={"Tell us\u2026 (optional)"} text={answers.jobFunctionOther} onTextChanged={roleOther => onAnswersChange({
      jobFunctionOther: roleOther
    })} />;
    $[7] = answers.jobFunctionOther;
    $[8] = onAnswersChange;
    $[9] = shouldShowOther;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <AnalyticsFeedbackStepLayout title="What best describes your role?">{t3}{t4}</AnalyticsFeedbackStepLayout>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}

/** Step definition registered in the survey flow. */
export const analyticsFeedbackStep3 = {
  stepName: "role",
  StepComponent: AnalyticsFeedbackStep3Content,
  isValid
};